<template>
  <b-form-group
    :label="title"
    :label-for="id"
    :description="description"
    label-cols-sm="3"
  >
  <template v-slot:description>
    <slot name="description"></slot>
  </template>
  <b-form-file
    :id="id"
    v-model="addedFiles"
    :disabled="disabled"
    placeholder="ファイルを追加"
    drop-placeholder="ここにファイルをドロップ"
    :multiple="multiple"
    browse-text="変更"
    @input="fileAdded"
    :accept="accept"
  >
  </b-form-file>
  <slot>
  <!-- 他に表示する要素があればここに入る -->
  </slot>
</b-form-group>
</template>

<script>
export default {
  name: 'ElementFileForm',
  props: {
    title: String,
    id: String,
    description: {
      type: String,
      default: ''
    },
    vModel: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    required: {
      type: Boolean,
      default: false
    },
    files: {
      type: Array,
      default: function () {
        return []
      }
    },
    needReset: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    accept: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      addedFiles: this.files
    }
  },
  methods: {
    fileAdded: function () {
      this.$emit('fileAdded', this.addedFiles)
      if (this.needReset) {
        this.addedFiles = []
      }
    }
  }
}
</script>
